import React from 'react';
import PropTypes from 'prop-types';
const TEST_ID_DATA_ATTR = 'data-qa';

const testable = (nsp, Comp) => {
  const makeTestable = (Comp) => {
    const TestableWrapper = (givenProps) => {
      const newProps = { ...givenProps };

      if (typeof givenProps.testId === 'string') {
        const prefix = nsp ? `${nsp}-` : '';
        newProps[TEST_ID_DATA_ATTR] = `${prefix}${givenProps.testId}`;
      }
      delete newProps.testId;

      if (givenProps.innerRef) {
        newProps.ref = givenProps.innerRef;
      }
      delete newProps.innerRef;

      return <Comp {...newProps} />;
    };
    TestableWrapper.propTypes = {
      testId: PropTypes.string,
      innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
    };
    TestableWrapper.displayName = 'Testable';

    return TestableWrapper;
  };

  return Comp ? makeTestable(Comp) : makeTestable;
};

export default testable;
export const maltTestable = testable('malt');
